import { createSlice } from '@reduxjs/toolkit';

const userReducer = createSlice({
    name: 'user',
    initialState: {
        isLoggedIn: false,
        access_token: '',

    },
    reducers: {
        setUserInfo: (state, action) => {                        
            state.access_token = action.payload.token;
            state.isLoggedIn = action.payload.token ? true : false;
        },
        clearUserInfo: (state) => {
            state.isLoggedIn = false;
            state.access_token = '';
        }
        // opendetail: (state, action) => {
        //     state.detail = true;
        // },
        // offdetail: (state, action) => {
        //     state.detail = false;
        //     state.fullsize = false;
        // },
        // openfullsize: (state, action) => {
        //     state.fullsize = true;
        // },
        // closefullsize: (state, action) => {
        //     state.fullsize = false;
        // },
        // handlefullsize: (state, action) => {
        //     state.fullsize = !state.fullsize;
        //     state.autofit = !state.autofit;
        // },
        // handleOpenDraw: (state, action) => {
        //     state.openDraw = !state.openDraw;
        // },
    },
});

export default userReducer;
